import {useEffect, useState} from "react";
import ApiCall from "../api";
const useGetAPI = (url="") =>{
    const [data, setData] = useState([]);
    useEffect(() =>{
        const getAPI = async () =>{
            try {
                const response = await ApiCall({url: `${url}`, method: "GET", body:null});
                response.json().then((e)=>{
                    setData(e);
                })
            } catch (error) {
                setData([]);
            }
        }
        getAPI();
        return () =>{
            setData([]);
        }
    },[url])
    return data;
}
export default useGetAPI;